<template>
  <v-card>
    <v-card-title class="headline py-2">
      Изменить пароль
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-text-field
          label="Текущий пароль"
          type="password"
          :rules="passwordRules"
          v-model="old_password"
          required
        />
        <v-text-field
          label="Новый пароль"
          type="password"
          :rules="passwordRules"
          v-model="new_password"
          required
        />
        <v-text-field
          label="Повторите новый пароль"
          type="password"
          :rules="passwordConfirmRules"
          v-model="password_confirm"
          required
        />
      </v-form>

      
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="changePassword" :disabled="!valid|| status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
import apiAccount from "../../../api"

export default {
  name : 'PasswordForm',
  
  data() {
    return {
      old_password: '',
      new_password: '',
      password_confirm: '',

      valid: false,
      passwordRules: [
        v => !!v || 'Необходимо ввести пароль',
        v => (v && v.length >= 10 && v.length <= 16) || 'Длина пароля должна быть от 10 до 16 символов'
      ],
      passwordConfirmRules: [
        v => !!v || 'Необходимо ввести подтверждение пароля',
        v => (v === this.new_password) || 'Подтверждение пароля не совпадает с паролем'
      ],
      status:{
        btnDisabled: false,
        text: '',
        className:'success--text darken-1'
      },
    }
  },
  
  methods : {
    changePassword() {
      if (this.$refs.form.validate()) {
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        apiAccount.changePassword({
          old_password: this.old_password,
          password: this.new_password,
          password_confirm: this.password_confirm
        }).then(response => {
          this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
          this.$dmsSuccessNoty('Ваш пароль успешно изменен')
          this.$emit('close-dialog')
        }).catch(error => {
          let errmessage = (error.response) ? error.response.data.error : 'Ошибка'
          this.status={ btnDisabled: false, text: errmessage, className:'error--text darken-1' }
        })
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Forms/PasswordForm.vue